
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl, baseUrl2 } from "../../../../boot";

// Helper function to ensure no double slashes
const getApiUrl = (endpoint) => {
  // Remove trailing slash from baseUrl if it exists
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  // Remove leading slash from endpoint if it exists (since baseUrl already has /server/)
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  const fullUrl = `${cleanBaseUrl}/${cleanEndpoint}`;
  console.log('Full API URL:', fullUrl);
  return fullUrl;
};

export const getContactByEmail = async (email) => {
    try {
        const url = `${baseUrl}crm/api/v1/check-Contact-By-Email`;
        console.log("Contact API URL:", url);
        
        const res = await axios.post(url, { email });
        console.log("Contact check result:", res);
        return res.data;
    } catch (error) {
        console.error("Contact API error:", error);
        throw error;
    }
};

// export const getLeadByEmail = async (email) => {
//     try {
//         const url = `${baseUrl}/crm/api/v1/get-lead-by-email`;
//         console.log("Contact API URL:", url);
        
//         const res = await axios.post(url, { email });
//         console.log("Contact check result:", res);
//         return res.data;
//     } catch (error) {
//         console.error("Contact API error:", error);
//         throw error;
//     }
// };

export const getLeadByEmail = createAsyncThunk(
    "checkout/getLeadByEmail",
    async (email, { rejectWithValue }) => {
        try {
            const url = `${baseUrl}crm/api/v1/get-lead-by-email`;
            console.log("Lead API URL:", url);
            
            const res = await axios.post(url, { email });
            return res.data;
        } catch (error) {
            console.error("Lead API error:", error);
            return rejectWithValue(error.response?.data || "Lead not found");
        }
    },
);

export const convertLeadToClient = createAsyncThunk(
    "checkout/convertLeadToClient",
    async (leadId, { rejectWithValue }) => {
        try {
            const url = `${baseUrl}crm/api/v1/convert-lead-to-company-and-client`;
            console.log("Convert API URL:", url);
            
            const res = await axios.post(url, { leadId });
            return res.data;
        } catch (error) {
            console.error("Convert API error:", error);
            return rejectWithValue(error.response?.data || "Lead conversion failed");
        }
    },
);


export const deleteAddress = createAsyncThunk(
  "customerAddress/deleteAddress",
  async (addressId, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}delivery-address/api/v1/delete/${addressId}`;
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Delete Address Error:", error);
      return rejectWithValue(error.response?.data || { message: "Failed to delete address" });
    }
  }
);

export const updateAddress = createAsyncThunk(
  "customerAddress/updateAddress",
  async ({ addressId, addressData }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}delivery-address/api/v1/update/${addressId}`;
      const response = await axios.put(url, addressData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Update Address Error:", error);
      return rejectWithValue(error.response?.data || "Failed to update address");
    }
  }
);


// Update this function to accept shippingCharges and total
export const convertcartToSalesOrder = async (contactId, selectedAddressId, shippingCharges, total, subtotal) => {
  const userId = localStorage.getItem("UserRowId");
  if (!userId) {
    throw new Error("User ID not found");
  }

  try {
    const response = await axios.post(
      `${baseUrl}sales/orders/api/v1/convert-cart-to-sales/${userId}`,
      {
        contactId: contactId,
        deliveryAddressId: selectedAddressId,
        shippingCharges: shippingCharges,
        total: total,
        subTotal:subtotal
      },
      {
        headers: {
          // Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          
        },
      }
    );

    console.log("Cart converted to Sales Order:", response.data);
    return response.data;

  } catch (error) {
    console.error("Error converting cart:", error);
    throw error;
  }
};

export const sendPaymentMail = async ({ orderId, paymentLink, organisationid }) => {
  try {
    const response = await axios.post(
      `${baseUrl}sales/orders/api/v1/send-payment-mail`,
      { orderId, paymentLink, organisationid }
    );

    return response.data;
  } catch (error) {
    // console.error("Error sending payment mail:", error?.response?.data);
    throw error?.response?.data || { message: "Something went wrong" };
  }
};

export const createRazorpayOrder = async ({ amount, rowId }) => {
  try {
    console.log("Sending request to:", "http://localhost:3001/server/razorpaywebhook/rzpay/create-order");
    console.log("Payload:", { amount, rowId });
    
    const response = await axios.post(
      `${baseUrl2}razorpaywebhook/rzpay/create-order`,
      // "http://localhost:3001/server/razorpaywebhook/rzpay/create-order",
      {
        amount,
        rowId
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    console.log("Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating Razorpay order:", error);
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.error("Error request:", error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error("Error message:", error.message);
    }
    throw error;
  }
};

export const createRazorpayPaymentLink = async ({ amount, rowId, customerName, customerEmail, customerPhone }) => {
  try {
    console.log("Creating Razorpay payment link with:", { amount, rowId, customerName, customerEmail, customerPhone });
    
    const response = await axios.post(
      `${baseUrl2}razorpaywebhook/rzpay/create-payment-link`,
      // "http://localhost:3001/server/razorpaywebhook/rzpay/create-payment-link",
      {
        amount,
        rowId,
        customerName,
        customerEmail,
        customerPhone
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    console.log("Razorpay payment link response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error creating Razorpay payment link:", error);
    if (error.response) {
      console.error("Error response:", error.response.data);
      throw new Error(error.response.data.message || "Failed to create payment link");
    }
    throw error;
  }
};

export const checkPaymentStatus = async (orderId) => {
  try {
    const response = await axios.get(

      `${baseUrl2}razorpaywebhook/rzpay/payment-status/${orderId}`,
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error checking payment status:", error);
    throw error;
  }
};

// export const convertcartToSalesOrder = async (contactId,selectedAddressId) => {
//   const userId = localStorage.getItem("UserRowId");
//   if (!userId) {
//     throw new Error("User ID not found");
//   }

//   try {
//     const response = await axios.post(
//       `${baseUrl}sales/orders/api/v1/convert-cart-to-sales/${userId}`,
//       {
//         contactId: contactId,
//         deliveryAddressId: selectedAddressId,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//         },
//       }
//     );

//     console.log("Cart converted to Sales Order:", response.data);
//     return response.data;

//   } catch (error) {
//     console.error("Error converting cart:", error);
//     throw error;
//   }
// };